module.exports = __webpack_public_path__ + "img/4.f3dd9063.png";